module.exports = __webpack_public_path__ + "static/media/comic-move-07.68a64dd5.png";